var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  require("!!vue-loader/node_modules/vue-style-loader!css-loader?sourceMap!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-b3a5658c\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=styles&index=0!./xheader.vue")
}
var Component = require("!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=script&index=0!./xheader.vue"),
  /* template */
  require("!!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/template-compiler/index?{\"id\":\"data-v-b3a5658c\",\"hasScoped\":true}!../../node_modules/_vue-loader@12.2.2@vue-loader/lib/selector?type=template&index=0!./xheader.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b3a5658c",
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "D:\\daima\\nodejs\\angular\\news\\Pretty-Talks\\pretty\\app\\component\\xheader.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] xheader.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-loader/node_modules/vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b3a5658c", Component.options)
  } else {
    hotAPI.reload("data-v-b3a5658c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./app/component/xheader.vue
// module id = 23
// module chunks = 0